<template>
  <div class="quiz-container">
        <TopPanel />
</div>
    <div class="main-content">
      <div class="quiz-content">
        <div v-show="showscore" class="score-content">
          <span class="pi pi-trophy" style="font-size: 1.6rem"></span> 
          <div class="score-text">
          <h2>   Your score is {{score}} out of {{items.length}}</h2>
          <h3>Percentage Score: {{(score/items.length).toFixed(2)*100}}% </h3>
          </div>
          <button v-show="!showsolutions" class="submit-button" @click="displaysols">Show Solutions</button>
          <hr class="score-divider">
        </div >
            <div v-show="showsolutions" class="question-content" v-for="q in items" :key="q.id">
              
              <div v-if="q.type=='singleCorrect'">
                  <div class="question-text">
                      <div class="numbering">{{q.id }}</div>
                      <div class= "text-details">
                          <pre><h4>{{q.text}}</h4></pre>

                          
                          <label><input class="input-form" type="radio" :name="q.id" :value="q.optiona" v-model="q.selecteda" >{{q.optiona}}</label><br>
                          
                          <label><input type="radio" :name="q.id" :value="q.optionb" v-model="q.selecteda" >{{q.optionb}}</label><br>
                          
                          <label><input type="radio" :name="q.id" :value="q.optionc"  v-model="q.selecteda">{{q.optionc}}</label><br>
                      
                          <label><input type="radio" :name="q.id" :value="q.optiond"  v-model="q.selecteda">{{q.optiond}}</label><br>  
                          <p v-show="showscore">Your Answer: {{q.selecteda}}</p>
                          <p v-show="showscore">Correct Answer: {{q.correct}}</p>
                      </div>
              </div>


              </div>
                <div v-else-if="q.type=='fillblanks'">
                  <div class="question-text"> 
                    <div class="numbering">
                        {{q.id }}
                    </div>
                    <div class= "text-details">
                       <pre><h4> {{q.text}} <input type="text" v-model="q.selecteda"> {{q.text2}}</h4></pre> 
                        <p v-show="showscore">Your Answer: {{q.selecteda}}</p>
                        <p v-show="showscore">Correct Answer: {{q.correct}}</p>
                    </div>
                  </div>
              </div>


                <div v-else>
                  <div class="question-text">
                    <div class="numbering">
                        {{q.id }}
                    </div>
                   <div class="text-details">
                    <pre><h4>{{q.text}}</h4></pre>
                        
                        <label><input type="checkbox" :id="q.optiona" :value="q.optiona"  v-model="q.selectedb" >{{q.optiona}}</label><br>
                        
                        <label><input type="checkbox" :id="q.optionb" :value="q.optionb"  v-model="q.selectedb">{{q.optionb}}</label><br>
                        
                        <label><input type="checkbox" :id="q.optionc" :value="q.optionc"  v-model="q.selectedb">{{q.optionc}}</label><br>
                        
                        <label><input type="checkbox" :id="q.optiond" :value="q.optiond"  v-model="q.selectedb">{{q.optiond}}</label><br>
                         <p v-show="showscore">Your Answer: {{q.selectedb}}</p>
                        <p v-show="showscore">Correct Answer: {{q.correct}}</p>    
                    </div>  
                </div>
              </div>
     
</div>
        <p v-for="cour in course" :key="cour.id">{{ cour.content }}</p>
        <button v-show="aftersubmit" @click="evaluation" class="submit-button">Submit</button>
       
     
     
  </div>
    </div>
</template>





<script>
import TopPanel from './TopPanel.vue'; 
import { supabase } from '@/supabase.js'
import { quizdata } from '@/stores/quizStore.js';


export default {
  data(){
    return{
      course:[],
      hidata:false,
      score:0,
      items:[],
      picked:null,
      showscore:false,
      showsolutions:true,
      aftersubmit:true,
      quesindex:0,
      quizques:quizdata
      }
    
  },
  async created() {
  
    const {data , error} = await supabase.from('questions').select('*');
    if (error) {
      console.error(error);
    }else {      
      this.items=data;

    }
 
    
  },
  
  methods:{
    showhi(){
      this.hidata = !this.hidata
    },
    evaluation(){
      for (let i = 0; i < this.items.length; i++) {
        const currquestion = this.items[i]
     if (currquestion.type!="multiCorrect"){
      if(currquestion.selecteda!=null){
        if(currquestion.selecteda.toLowerCase().replace(/\s/g, "")===currquestion.correct.toLowerCase().replace(/\s/g, "")){
          this.score = this.score+1
        }
      }
     }
     else if ((currquestion.selectedb.join(',').split('').sort().join(''))==(currquestion.correct.split('').sort().join('')) && currquestion.type=="multiCorrect"){
         this.score = this.score+1
      }
      this.aftersubmit=false
      this.showscore=true
      this.showsolutions=false


}
    
        
    },

displayscore(){
  this.showscore = true
},


displaysols(){
this.showsolutions = true;
}  

},



components: {
    TopPanel,
}
};
</script>





<style scoped>

.main-content {
  display: flex;
  background: #1a1625 ;
  min-height: 100vh;
}

.quiz-content{
  width: 80vw;
  align-items: center;
  justify-content: center;
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 10vh;
  padding-bottom: 10vh;

}

.question-text{
  display: flex;
}

.question-content{
  color: white;
  padding: 20px;
  font-size: 18px;
  overflow: auto;
  border: 1px solid gray;
  margin-bottom: 3%;
  background:  #2f2b3a;
  border-radius: 7px;
  min-height: 25vh;
  text-align: left;
}

.question-content:hover{
  border: 1px solid cyan;
}

.numbering{
  margin-top:1%;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  padding: 7px;
  background: #ffff99;
  /* border: 3px solid cyan; */
  color: #1a1625;
  text-align: center;
  margin-right: 6vw;
  font: 28px Hevelentica,Arial, sans-serif;

}

.text-details{
  max-width: 85%;
}



pre {
    white-space: pre-wrap;      
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
}


.submit-button{
  width:170px;
  background-color: #ffff99;
  color: #1a1625;
  border: 1px solid gray;
  font-size: 16px;
  margin-bottom: 20px;
  margin-top: 20px;
  padding: 8px;
  margin-top:8px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ddd;
  transition: background-color 0.3s;
  text-align: center;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}

.submit-button:hover{
  border: 1px solid cyan;
}

.score-content{
  color:white;
  margin-bottom: 10%;
}

.score-text{
  margin-bottom: 100px;
}

.main-divider{
 /* background-color: red; */
 border-color: #ffffff; 
 max-width: 84%;
 margin-left: 8%;
 margin-top: 50px;
}

@media only screen and (max-width: 800px) {
 .question-content{
  font-size:15px ;
 }

 .numbering{
  margin-top:15px;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  padding: 7px;
  /* background: #ffff99;
  /* border: 3px solid cyan; */
  /* color: #1a1625;
  text-align: center;
  margin-right: 6vw; */
  font: 16px Hevelentica,Arial, sans-serif;

}
}

</style>